import { ResumedSignupData, resumeSignupFromLeadID } from 'domains/signupDirect/ResumeLead/resumeLead';
import { ResumeSignupLeadFormType } from 'domains/signupDirect/ResumeLead/resumeSchema';

export const onSubmitLeadVerification = async (
  data: ResumeSignupLeadFormType,
): Promise<ResumedSignupData | undefined> => {
  const result = await resumeSignupFromLeadID(data.leadID, {
    email: data.email,
    phone: data.phone,
  });

  return result;
};
